import { defineMessages } from 'react-intl';

export default defineMessages({
  TITLE_PLACEHOLDER: {
    defaultMessage: 'Unknown title',
  },

  DESCRIPTION_PLACEHOLDER: {
    defaultMessage: 'Unknown description',
  },
} as const);
